import React, { useContext, useEffect, useState } from 'react';
import { GlobalStore } from '../../../StateStores';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Form, FormFeedback, Input, Label, ListGroup, ListGroupItem, Row, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchLicenseStatus } from '../../../Actions/InspectionActs';
import moment from 'moment';

const LicenseStatus = ({canvas,setCanvas})=>{
    const navigate = useNavigate();
    const [formValid, setFormValid] = useState(false);
    const [form,setForm] = useState({license_no:'',});
    const [formErrors,setFormErrors] = useState({license_no:'License is required',});
    const [licenseData,setLicenseData] = useState({});

    const {InspectionDispatch,InspectionState:{
        getLicenseStatus:{error,loading,data},
    }} = useContext(GlobalStore);

    useEffect(() => {
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    const onChange = ({name,value}) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        if(formValid){
            try {
                const response = await fetchLicenseStatus(form)(InspectionDispatch);
                
                if(response.status){
                    const {license} = response.data;
                    setLicenseData(license)
                }else{
                    toast.error(response.message)
                }
            } catch (error) {
                toast.error(error.message)
            }
        }
    }

    /**
     * Clear the searched data
     */
    const clearFetchedData = ()=>{
        setLicenseData({})
        setForm({license_no:''})
        setFormErrors({license_no:'License is required is required'})
    }

    return(
        <React.Fragment>
            <div className={`d-flex flex-column justify-content-center align-items-center ${Object.keys(licenseData).length > 0? '':'h-100'}`}>
                {Object.keys(licenseData).length === 0 && (
                    <div className="w-100 px-3a">
                        <Form onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    <Label>Enter license number</Label>
                                    <Input 
                                        type='text' 
                                        placeholder='Enter license No.'
                                        value={form?.license_no}
                                        onChange={(e) => onChange({name:'license_no',value:e.target.value})}
                                        valid={formErrors.license_no === ''}
                                        invalid={formErrors.license_no !== ''}
                                    />
                                    {formErrors.license_no && <FormFeedback>{formErrors.license_no}</FormFeedback>}
                                </Col>
                            </Row>
                            <div className='mt-2 d-flex justify-content-end'>
                                <Button disabled={!formValid} size='sm'>
                                    {loading && <Spinner size="sm"/>}
                                    <span className='ms-1'>Fetch data</span>
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
                
                {Object.keys(licenseData).length > 0 && (
                    <React.Fragment>
                        <div className='w-100'>
                            <Card className='shadow-sm'>
                                <CardHeader>License Details</CardHeader>
                                <CardBody>
                                    <ListGroup>
                                        <ListGroupItem>
                                            <div><strong>Driver:</strong></div>
                                            <small>{licenseData?.driver}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Licence:</strong></div>
                                            <small>{licenseData?.licence}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>tin:</strong></div>
                                            <small>{licenseData?.tin}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Address:</strong></div>
                                            <small>{licenseData?.address}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Expiry Date:</strong></div>
                                            <div><small className="text-muted">{moment(licenseData?.expirydate).format('LL HH:mm:ssa')}</small></div>
                                            <small className="text-info text-muted ms-1s">{moment(licenseData?.expirydate).startOf().fromNow()}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Vehicle:</strong></div>
                                            <small>{licenseData?.vehicle}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Mobile:</strong></div>
                                            <small>{licenseData?.tmobile}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Location:</strong></div>
                                            <small>{licenseData?.tlocation}</small>
                                        </ListGroupItem>
                                    </ListGroup>
                                </CardBody>
                            </Card>
                        </div>
                        <div className='d-flex justify-content-end'>
                            <Button size='sm' onClick={clearFetchedData}>
                                <span className='ms-1'>Reset</span>
                            </Button>
                        </div>
                    </React.Fragment>
                )}

                
            </div>
        </React.Fragment>
    )
}

export default LicenseStatus;